export default {"src":"/_next/static/media/icon-log.d2098ea4.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};